export default __webpack_public_path__ + "static/media/7A780C72-1E5C-4114-8BE7-3FF285823835_1_105_c.bc2d3c79.jpeg";